"use client"
import logger from "@/lib/logger/logger-init"
import { ResultFactory } from "@/types/generic/Result"

type DeleteItemFromBasketResult = {
    success: boolean
    data?: any
    error?: Error
}

export const deleteItemFromBasket = async (lineId: string) => {
    try {
        const response = await fetch("/api/centra/delete-item", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ lineId })
        })

        const result = await response.json()

        if (!response.ok || !result.success) {
            const errorMessage = result.error || "Failed to delete item"
            logger.warn(errorMessage)
            return ResultFactory.failure<DeleteItemFromBasketResult>(
                new Error(errorMessage)
            )
        }

        const successMessage = "Item deleted from basket"
        logger.info(successMessage, {
            data: result.data
        })
        return ResultFactory.success<DeleteItemFromBasketResult>({
            success: true,
            data: result.data
        })
    } catch (error) {
        logger.error("Unexpected error in deleteItemFromBasket", error)
        return ResultFactory.failure<DeleteItemFromBasketResult>(
            error instanceof Error ? error : new Error("An unknown error occurred")
        )
    }
}
